module.exports = __webpack_public_path__ + "static/img/KY.ace5d023.svg";